import React from 'react';
import { Link } from 'react-router-dom';

export default function MediaItem({ item }) {
  return (
    <div className="w-100 text-center ">
      <Link className='text-decoration-none' to={`/itemdetails/${item.id}/${item.media_type}`}>
        <div className="movie position-relative w-100 h-100">
          {item.poster_path ? (
            <img className="w-100" src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`} alt={item.title || item.name} />
          ) : (
            <img className="w-100" src={`https://image.tmdb.org/t/p/w500/${item.profile_path}`} alt={item.title || item.name} />
          )}
          <h4 className="h6 my-2">{item.title || item.name}</h4>
          {item.vote_average && (
            <div className="vote p-2 text-white position-absolute top-0 end-0">
              {item.vote_average.toFixed(1)}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
}
